document.addEventListener('DOMContentLoaded', function() {
    // DOM elements
    const passwordInput = document.getElementById('password');
    const generateBtn = document.getElementById('generateBtn');
    const copyBtn = document.getElementById('copyBtn');
    const lengthSlider = document.getElementById('length');
    const lengthValue = document.getElementById('lengthValue');
    const uppercaseCheckbox = document.getElementById('uppercase');
    const lowercaseCheckbox = document.getElementById('lowercase');
    const numbersCheckbox = document.getElementById('numbers');
    const symbolsCheckbox = document.getElementById('symbols');
    const excludeSimilarCheckbox = document.getElementById('excludeSimilar');
    const excludeAmbiguousCheckbox = document.getElementById('excludeAmbiguous');
    const strengthFill = document.getElementById('strengthFill');
    const strengthText = document.getElementById('strengthText');

    if (!passwordInput || !generateBtn || !copyBtn || !lengthSlider || !lengthValue ||
        !uppercaseCheckbox || !lowercaseCheckbox || !numbersCheckbox || !symbolsCheckbox ||
        !excludeSimilarCheckbox || !excludeAmbiguousCheckbox || !strengthFill || !strengthText) {
        console.error('One or more elements are missing from the DOM.');
        return;
    }

    // Character sets
    const uppercaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lowercaseChars = 'abcdefghijklmnopqrstuvwxyz';
    const numberChars = '0123456789';
    const symbolChars = '!@#$%^&*()_+-=[]{}|;:,.<>?';
    const similarChars = 'il1Lo0O';
    const ambiguousChars = '[]{}()<>';

    // Update length value display
    lengthSlider.addEventListener('input', function() {
        lengthValue.textContent = this.value;
    });

    // Generate password function
    function generatePassword() {
        const length = parseInt(lengthSlider.value);
        let charset = '';
        let password = '';

        // Build character set based on selected options
        if (uppercaseCheckbox.checked) {
            charset += uppercaseChars;
        }
        if (lowercaseCheckbox.checked) {
            charset += lowercaseChars;
        }
        if (numbersCheckbox.checked) {
            charset += numberChars;
        }
        if (symbolsCheckbox.checked) {
            charset += symbolChars;
        }

        // Remove similar characters if option is selected
        if (excludeSimilarCheckbox.checked) {
            charset = charset.replace(new RegExp(`[${similarChars}]`, 'g'), '');
        }

        // Remove ambiguous characters if option is selected
        if (excludeAmbiguousCheckbox.checked) {
            charset = charset.replace(new RegExp(`[${ambiguousChars}]`, 'g'), '');
        }

        // Ensure at least one character set is selected
        if (charset === '') {
            alert('Please select at least one character type!');
            return '';
        }

        // Generate password
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * charset.length);
            password += charset[randomIndex];
        }

        return password;
    }

    // Update password strength
    function updatePasswordStrength(password) {
        let strength = 0;
        const length = password.length;

        // Length contributes to strength
        if (length >= 8) strength += 1;
        if (length >= 12) strength += 1;
        if (length >= 16) strength += 1;

        // Character variety contributes to strength
        if (/[A-Z]/.test(password)) strength += 1;
        if (/[a-z]/.test(password)) strength += 1;
        if (/[0-9]/.test(password)) strength += 1;
        if (/[^A-Za-z0-9]/.test(password)) strength += 1;

        // Update UI based on strength
        strengthFill.className = 'strength-fill';
        strengthFill.classList.remove('weak', 'medium', 'strong');
        if (strength <= 2) {
            strengthFill.classList.add('weak');
            strengthText.textContent = 'Weak';
        } else if (strength <= 4) {
            strengthFill.classList.add('medium');
            strengthText.textContent = 'Medium';
        } else {
            strengthFill.classList.add('strong');
            strengthText.textContent = 'Strong';
        }
    }

    // Generate password on button click
    generateBtn.addEventListener('click', function() {
        let newPassword = generatePassword();
        passwordInput.value = newPassword;
        updatePasswordStrength(newPassword);
    });

    // Copy password to clipboard using the modern Clipboard API
    copyBtn.addEventListener('click', function() {
        if (passwordInput.value) {
            navigator.clipboard.writeText(passwordInput.value).then(() => {
                // Visual feedback
                const originalText = copyBtn.textContent;
                copyBtn.textContent = 'Copied!';
                setTimeout(() => {
                    copyBtn.textContent = originalText;
                }, 2000);
            }).catch(err => {
                console.error('Could not copy text: ', err);
                alert('Failed to copy password.');
            });
        }
    });

    // Generate initial password on load
    generateBtn.click();
});